import Image from '../../images/welcome-portrait.webp'

const Landing = () => {

  return (
    <section className="landing">
        <div className="landing__container container">
          <div className="landing__img-container">
            <img className="landing__img" src={Image} alt="" />
          </div>
        </div>
    </section>
  )
}

export default Landing
